import withPliErrorBoundary from '@/components/blocks/ErrorBoundary/withPliErrorBoundary';
import { ComponentFailureVariant } from './util';
import { ComponentFailurePlaceholderBlockProps } from './ComponentFailurePlaceholderBlock';
import { ReactNode } from 'react';

export type PanelContentWithErrorBoundaryProps = ComponentWithChildren &
  ComponentFailurePlaceholderBlockProps & {
    bubbleError?: boolean;
    errorBoundaryName?: string;
    variant?: ComponentFailureVariant;
    fallback?: ReactNode;
  };

const PanelContentContainer: React.FC<PanelContentWithErrorBoundaryProps> = ({
  children,
  bubbleError
}) => {
  if (bubbleError) throw Error;
  return <>{children}</>;
};

const PanelContentWithErrorBoundary = withPliErrorBoundary(PanelContentContainer, {
  variant: ComponentFailureVariant.spaceBetween
});

export default PanelContentWithErrorBoundary;
